import { staticFile } from '@common/utils'
import classNames from 'classnames'

type Props = {
  onClick: () => void
  image: string
  title: string
  disabled?: boolean
}

const ArenaButton = ({ image, onClick, title, disabled = false }: Props) => (
  <div className="flex flex-col items-center space-y-1 w-16">
    <button
      onClick={onClick}
      className={classNames('focus:outline-none', {
        'opacity-50 cursor-not-allowed': disabled,
        'hover:opacity-75': !disabled,
      })}
      disabled={disabled}
    >
      <img src={staticFile(image)} className="w-8" />
    </button>
    <p className="font-600 text-sm">{title}</p>
  </div>
)

export default ArenaButton
